import {
  OnboardingActionTypes,
  IFetchQuickstartSettingsSuccessResponseBody,
  IStartQuickstartProcessingPayload,
} from './types'

export const fetchQuickstartSettings = () => ({
  type: OnboardingActionTypes.FETCH_QUICKSTART_SETTINGS,
})

export const fetchQuickstartSettingsSuccess = (payload: IFetchQuickstartSettingsSuccessResponseBody) => ({
  type: OnboardingActionTypes.FETCH_QUICKSTART_SETTINGS_SUCCESS,
  payload,
})

export const fetchQuickstartSettingsFailure = () => ({
  type: OnboardingActionTypes.FETCH_QUICKSTART_SETTINGS_FAILURE,
})

export const startQuickstartProcessing = (payload: IStartQuickstartProcessingPayload) => ({
  type: OnboardingActionTypes.START_QUICKSTART_PROCESSING,
  payload,
})

export const startQuickstartProcessingSuccess = () => ({
  type: OnboardingActionTypes.START_QUICKSTART_PROCESSING_SUCCESS,
})

export const startQuickstartProcessingFailure = () => ({
  type: OnboardingActionTypes.START_QUICKSTART_PROCESSING_FAILURE,
})

export const finishSurvey = () => ({
  type: OnboardingActionTypes.FINISH_SURVEY,
})

export const finishSurveySuccess = () => ({
  type: OnboardingActionTypes.FINISH_SURVEY_SUCCESS,
})

export const finishSurveyFailure = () => ({
  type: OnboardingActionTypes.FINISH_SURVEY_FAILURE,
})

export const getForwardingPath = () => ({
  type: OnboardingActionTypes.GET_FORWARDING_PATH,
})
